import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { INotification } from '../../../types/notifications'
import { getUrlWithVersion } from '../../../api/api'
import { selectProducts } from '../../selectors/productsSelectors'

export const fetchMoreNotifications = createAsyncThunk<
    { hasMore: boolean; notifications: INotification[] } | void,
    { lastNotificationId: string | undefined; productIds: string[] },
    ThunkConfig<string>
>('notificationsSlice/fetchMoreNotifications', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        getState,
    } = thunkAPI
    const { lastNotificationId, productIds } = args

    const products = selectProducts(getState())
    const isFetchAll = products?.length === productIds?.length || productIds?.length === 0
    const product_ids = isFetchAll ? null : productIds


    try {
        const { data } = await api.post<{
            notifications: INotification[]
            has_more: boolean
        }>(getUrlWithVersion(`/notifications`), {
            before: lastNotificationId,
            product_ids,
        })

        if (
            typeof data?.has_more !== 'boolean' ||
            !Array.isArray(data?.notifications)
        ) {
            const error = new Error('Received notifications in wrong format')
            console.error(error.message)
            return
        }

        return { hasMore: data.has_more, notifications: data.notifications }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to load more notifications')
    }
})
